export enum ContentType {
    Blog = 0,
    Help = 1
}

export enum PosterType {
    Image = 0,
    Video = 1
}